/** Matches mobile hero carousel capacity (`featuredCarouselLimit`). */
export const FEATURED_CAROUSEL_LIMIT = 5;

/** @deprecated Use FEATURED_CAROUSEL_LIMIT */
export const MAX_ACTIVE_PINS = FEATURED_CAROUSEL_LIMIT;

/** @deprecated Legacy field — always stored as 0; no UI for priority tiers. */
export const PIN_PRIORITY = {
  NORMAL: 0,
};

export function parsePinnedUntil(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (value instanceof Date) return value;
  return null;
}

export function isPinnedActive(item, now = new Date()) {
  const until = parsePinnedUntil(item?.pinnedUntil);
  return until != null && until.getTime() > now.getTime();
}

export function sortPinnedItems(items, now = new Date()) {
  return items
    .filter((item) => isPinnedActive(item, now))
    .sort((a, b) => {
      const untilA = parsePinnedUntil(a.pinnedUntil)?.getTime() ?? 0;
      const untilB = parsePinnedUntil(b.pinnedUntil)?.getTime() ?? 0;
      if (untilA !== untilB) return untilA - untilB;

      return (b.createdAt?.getTime?.() ?? 0) - (a.createdAt?.getTime?.() ?? 0);
    });
}

export function formatPinnedUntil(pinnedUntil, locale = 'sl-SI') {
  const date = formatPinnedUntilDate(pinnedUntil, locale);
  if (!date) return '';
  return `Pripeto do ${date}`;
}

export function formatPinnedUntilDate(pinnedUntil, locale = 'sl-SI') {
  const date = parsePinnedUntil(pinnedUntil);
  if (!date) return '';
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'numeric',
  });
}

export function formatPinnedUntilLongDate(pinnedUntil, locale = 'sl-SI') {
  const date = parsePinnedUntil(pinnedUntil);
  if (!date) return '';
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
  });
}

export function mergePinnedWithPageItems(pinnedItems, pageItems, { pageIndex = 0 } = {}) {
  if (pageIndex !== 0 || !pinnedItems?.length) {
    return pageItems;
  }

  const pinnedIds = new Set(pinnedItems.map((item) => item.id));
  const rest = pageItems.filter((item) => !pinnedIds.has(item.id));
  return [...pinnedItems, ...rest];
}

export function countActivePins(items, now = new Date()) {
  return items.filter((item) => isPinnedActive(item, now)).length;
}

export function willOverflowFeaturedCarousel(
  activeCountExcludingCurrent,
  willBePinned = true,
) {
  if (!willBePinned) return false;
  return activeCountExcludingCurrent >= FEATURED_CAROUSEL_LIMIT;
}

export function endOfLocalDay(dateInput) {
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  date.setHours(23, 59, 59, 999);
  return date;
}

export function defaultPinnedUntil(daysFromNow = 7) {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return endOfLocalDay(date);
}

export function toDateInputValue(value) {
  const date = parsePinnedUntil(value);
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function buildPinFields({ isPinned, pinnedUntilDate }) {
  if (!isPinned) {
    return {
      pinnedUntil: null,
      pinPriority: PIN_PRIORITY.NORMAL,
    };
  }

  const until = endOfLocalDay(pinnedUntilDate);
  if (!until) {
    throw new Error('Izberite veljaven datum pin-a.');
  }

  return {
    pinnedUntil: until,
    pinPriority: PIN_PRIORITY.NORMAL,
  };
}
